<template>
  <RouterLink class="group" :to="{ name: 'work', params: { work: work.slug } }">
    <ImageWrap :image="work.thumb" />
    <div class="relative font-serif text-left mt-2">
      <span class="link-dot-absolute" />
      <div>{{ work.artist.name }}</div>
      <div>
        <span class="italic">{{ work.title }}</span
        ><template v-if="work.year">, {{ work.year }}</template>
      </div>
      <div v-if="work.price">£{{ work.price }}</div>
    </div>
  </RouterLink>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { WorkListing } from '@/types.ts';

export default defineComponent({
  props: {
    work: {
      type: Object as PropType<WorkListing>,
      required: true,
    },
  },
});
</script>
